import { useMutation } from '@tanstack/react-query';

import {
  type Calendar_DeleteEvent,
  gqlClient,
  graphql,
  queryClient,
} from '@tyro/api';
import { toast } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';
import { calendarKeys } from './keys';

const deleteEvent = graphql(/* GraphQL */ `
  mutation calendar_deleteCalendarEvents($input: Calendar_DeleteEvent!) {
    calendar_deleteCalendarEvents(input: $input) {
      success
    }
  }
`);

export function useDeleteCalendarEvents() {
  const { t } = useTranslation(['common']);

  return useMutation({
    mutationFn: async (input: Calendar_DeleteEvent) =>
      gqlClient.request(deleteEvent, { input }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: calendarKeys.all });
      toast.success(t('common:snackbarMessages.deleteSuccess'));
    },
    onError: () => {
      toast.error(t('common:snackbarMessages.errorFailed'));
    },
  });
}
